/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:400px;max-width:100%}.type-select[_ngcontent-%COMP%], .type-select[_ngcontent-%COMP%]   option[_ngcontent-%COMP%]{text-transform:capitalize}"];
export { styles as styles };
